"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/layout/index.vue"));
var _clientSubMenu = require("./subMenus/client-sub-menu");
var _leadsSubMenu = require("./subMenus/leads-sub-menu");
var _followUpsSubMenu = require("./subMenus/follow-ups-sub-menu");
var _clientsContactSubMenu = require("./subMenus/clients-contact-sub-menu");
const leadRouter = {
  path: '/leads',
  component: _index.default,
  redirect: 'noredirect',
  name: 'Lead Management',
  meta: {
    roles: ['Super Admin', 'Admin', 'Product Manager', 'System Admin', 'Sales Coordinator'],
    title: 'leadManagement.title',
    icon: 'chart'
  },
  children: [..._clientSubMenu.clientSubMenu, ..._clientsContactSubMenu.clientsContactSubMenu, ..._leadsSubMenu.leadSubMenu, ..._followUpsSubMenu.followUpSubMenu]
};
var _default = exports.default = leadRouter;